import loadScript from 'lib/loadScript'

export type SlotId = string
export type ContentUnitId = number

type FluentAditionApi = {
  load: () => FluentAditionApi
  completeRendering: () => FluentAditionApi
  renderSlot: (slotId: string) => FluentAditionApi
  registerAdfarm: (url: string) => FluentAditionApi
  setContentunitId: (unitId: number) => FluentAditionApi
  configureRenderSlot: (slotId: string) => FluentAditionApi
}

declare var window: Window & {
  adition: {
    srq: {
      push: (cb: (api: FluentAditionApi) => void) => void
    }
  }
}

const w = window

const loadedAdSlots = new Set()

export const loadAditionSDK = (): void => {
  loadScript('https://imagesrv.adition.com/js/srp.js', 'adition-jssdk')
}

export const configureAdition = (): void => {
  w.adition = w.adition || {}
  w.adition.srq = w.adition.srq || []

  w.adition.srq.push((api: FluentAditionApi) => {
    api.registerAdfarm('ad1.adfarm1.adition.com')
  })
}

export const renderSlot = (slotId: string, unitId: ContentUnitId): void => {
  w.adition.srq.push((api: FluentAditionApi) => {
    const spotId = `${slotId}-${unitId}`

    if (!loadedAdSlots.has(spotId)) {
      api
        .configureRenderSlot(slotId)
        .setContentunitId(unitId)

      api.renderSlot(slotId)

      loadedAdSlots.add(spotId)
    }

    api.load().completeRendering()
  })
}
